export const data = [
    {
        name:"David Seiler",
        city:"Melbourne",
        sales:"50Kw",
        power:"12",
        ranking:"4",
    },
    {
        name:"Okan Boston",
        city:"Ft. Myers",
        sales:"50Kw",
        power:"12",
        ranking:"5"
    },
    {
        name:"David Seiler",
        city:"Melbourne",
        sales:"50Kw",
        power:"12",
        ranking:"6"
    },
    {
        name:"Okan Boston",
        city:"Ft. Myers",
        sales:"50Kw",
        power:"12",
        ranking:"7"
    },
    {
        name:"David Seiler",
        city:"Melbourne",
        sales:"50Kw",
        power:"12",
        ranking:"8"
    },
    {
        name:"Okan Boston",
        city:"Ft. Myers",
        sales:"50Kw",
        power:"12",
        ranking:"9"
    },
    {
        name:"David Seiler",
        city:"Melbourne",
        sales:"50Kw",
        power:"12",
        ranking:"10"
    },
   

]